import {
  VERTICAL_TIERS_LOADED,
  VERTICAL_TIERS_CLEAR,
  CUSTOMER_SUBSCRIPTION_LOADED,
  CUSTOMER_SUBSCRIPTION_CLEAR,
  ONBOARDING_PRICING_LOADED,
  ONBOARDING_PRICING_CLEAR,
  ONBOARDING_SUBMISSION_SUCCESS,
  ONBOARDING_SUBMISSION_CLEAR,
  ONBOARDING_PROVISIONING_SUCCESS,
  ONBOARDING_PROVISIONING_CLEAR,
  CUSTOMER_ONBOARDING_DATA_LOADING,
  CUSTOMER_ONBOARDING_DATA_LOADED,
  CUSTOMER_ONBOARDING_DATA_CLEAR,
  CANCELLATION_STATUS_LOADED,
  PLAN_MANAGEMENT_LOADING,
  PLAN_MANAGEMENT_LOADED,
  PLAN_MANAGEMENT_CLEAR,
  PLAN_UPGRADE_SUCCESS,
  PLAN_UPGRADE_CLEAR,
  PREFILL_ONBOARDING_DATA_LOADING,
  PREFILL_ONBOARDING_DATA_LOADED,
  PREFILL_ONBOARDING_DATA_CLEAR,
  PAYOUT_STATUS_LOADING,
  PAYOUT_STATUS_LOADED,
  PAYOUT_STATUS_CLEAR,
  PAYOUT_ACCOUNT_LOADING,
  PAYOUT_ACCOUNT_LOADED,
  PAYOUT_ACCOUNT_CLEAR,
} from '../actions/actionTypes';

const initialState = {
  verticalTiers: null,
  subscriptionData: null,
  cancellationRequestedAt: null,
  effectiveCancellationDate: null,
  ghlScheduleCancelledAt: null,
  onboardingPricing: null,
  onboardingSubmissionResponse: null,
  onboardingProvisioningResponse: null,
  customerOnboardingData: null,
  customerOnboardingDataLoading: false,
  planManagementData: null,
  planManagementLoading: false,
  planUpgradeResponse: null,
  prefillOnboardingData: null,
  prefillOnboardingDataLoading: false,
  payoutStatus: null,
  payoutStatusLoading: false,
  payoutAccount: null,
  payoutAccountLoading: false,
};

const payment = (state = initialState, action) => {
  switch (action.type) {
    case VERTICAL_TIERS_LOADED:
      return { ...state, verticalTiers: action.payload.verticalTiers };

    case VERTICAL_TIERS_CLEAR:
      return { ...state, verticalTiers: null };

    case CUSTOMER_SUBSCRIPTION_LOADED:
      return { ...state, subscriptionData: action.payload.subscription };

    case CUSTOMER_SUBSCRIPTION_CLEAR:
      return { ...state, subscriptionData: null };

    case ONBOARDING_PRICING_LOADED:
      return { ...state, onboardingPricing: action.payload.pricing };

    case ONBOARDING_PRICING_CLEAR:
      return { ...state, onboardingPricing: null };

    case ONBOARDING_SUBMISSION_SUCCESS:
      return { ...state, onboardingSubmissionResponse: action.payload.response };

    case ONBOARDING_SUBMISSION_CLEAR:
      return { ...state, onboardingSubmissionResponse: null };

    case ONBOARDING_PROVISIONING_SUCCESS:
      return { ...state, onboardingProvisioningResponse: action.payload.response };

    case ONBOARDING_PROVISIONING_CLEAR:
      return { ...state, onboardingProvisioningResponse: null };

    case CUSTOMER_ONBOARDING_DATA_LOADED:
      return { ...state, customerOnboardingData: action.payload.onboardingData };

    case CUSTOMER_ONBOARDING_DATA_CLEAR:
      return { ...state, customerOnboardingData: null };

    case CUSTOMER_ONBOARDING_DATA_LOADING:
      return { ...state, customerOnboardingDataLoading: action.payload.isLoading };

    case CANCELLATION_STATUS_LOADED:
      return {
        ...state,
        cancellationRequestedAt: action.payload.cancellationRequestedAt,
        effectiveCancellationDate: action.payload.effectiveCancellationDate,
        ghlScheduleCancelledAt: action.payload.ghlScheduleCancelledAt,
      };

    case PLAN_MANAGEMENT_LOADED:
      return { ...state, planManagementData: action.payload.planManagementData };

    case PLAN_MANAGEMENT_CLEAR:
      return { ...state, planManagementData: null };

    case PLAN_MANAGEMENT_LOADING:
      return { ...state, planManagementLoading: action.payload.isLoading };

    case PLAN_UPGRADE_SUCCESS:
      return { ...state, planUpgradeResponse: action.payload.upgradeResponse };

    case PLAN_UPGRADE_CLEAR:
      return { ...state, planUpgradeResponse: null };

    case PREFILL_ONBOARDING_DATA_LOADING:
      return { ...state, prefillOnboardingDataLoading: action.payload.isLoading };

    case PREFILL_ONBOARDING_DATA_LOADED:
      return { ...state, prefillOnboardingData: action.payload.data };

    case PREFILL_ONBOARDING_DATA_CLEAR:
      return { ...state, prefillOnboardingData: null, prefillOnboardingDataLoading: false };

    case PAYOUT_STATUS_LOADED:
      return { ...state, payoutStatus: action.payload.payoutStatus };

    case PAYOUT_STATUS_CLEAR:
      return { ...state, payoutStatus: null };

    case PAYOUT_STATUS_LOADING:
      return { ...state, payoutStatusLoading: action.payload.isLoading };

    case PAYOUT_ACCOUNT_LOADED:
      return { ...state, payoutAccount: action.payload.payoutAccount };

    case PAYOUT_ACCOUNT_CLEAR:
      return { ...state, payoutAccount: null };

    case PAYOUT_ACCOUNT_LOADING:
      return { ...state, payoutAccountLoading: action.payload.isLoading };

    default:
      return state;
  }
};

export default payment;
